import { memo } from 'react';
import { StepViewComponentProps } from '../stepDescriptor/types';
import QIRTextCollectionTaskComponent from './QIRTextCollectionTaskComponent';

function QIRTextCollectionViewComponent(props: StepViewComponentProps) {
  return <QIRTextCollectionTaskComponent {...props} isPinnable isPinnedView />;
}
export default memo(QIRTextCollectionViewComponent);
